import React, { useEffect, useState, Fragment, useRef } from "react";

import Navbar2 from "../components2/Navbar";
import Sidebar2 from "../components2/Sidebar.js";
import Select from "react-select";
import DateTimePicker from "react-datetime-picker";
import { Dialog, Transition } from "@headlessui/react";
import { ExclamationIcon } from "@heroicons/react/outline";
import { connect } from "react-redux";
import { gain_request, gain } from "../../../store/acion";
import finalPropsSelectorFactory from "react-redux/es/connect/selectorFactory";
import { async } from "@firebase/util";
import { useLocation, useNavigate } from "react-router-dom";
import {
  doc,
  setDoc,
  collection,
  getFirestore,
  waitForPendingWrites,
  updateDoc,
  onSnapshot,
  query,
  where
} from "firebase/firestore";
import axios from "axios";

function SheduledTeacher(props) {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const cancelButtonRef = useRef(null);

  const [value, setvalue] = useState();
  let [array, setArray] = useState();
  const [data_gain, setdata_gain] = useState(false);
  const [data_gain_2, setdata_gain_2] = useState(false);
  const [time, settime] = useState();

  const [request_data, setrequest_data] = useState([]);
  const [current_teacher, setcurrent_teacher] = useState();
  const [notification, setnotification] = useState();
  const [uid_popup, setuid_popup] = useState();

  // useEffect(() => {
  //   if (props.request != "fail") {
  //     let arr = props.request.filter(
  //       (e) => e.teacher_uid == localStorage.getItem("teacher_uid")
  //     );
  //     setrequest_data(arr);

  //     let arr1 = arr.length;
  // setArray(arr1);
  //   }
  // }, [data_gain]);
  
  useEffect(()=>{
 
   
   

   
    
      const db=getFirestore()
        onSnapshot(query(collection(db, "request"), where("teacher_uid", "==", localStorage.getItem("teacher_uid"))), (querySnapshot) => {


          let arr=[]
          querySnapshot.forEach( async (docs) => {
            
               

           arr.unshift(docs.data())
            });
  
       
           setrequest_data(arr);
           let arr1 = arr.length;
           setArray(arr1);
           setdata_gain(true);

  
  
      });
  },[])




  useEffect(() => {
    const db = getFirestore();
    onSnapshot(doc(db, "manage", "manage"), (doc) => {
      setdata_gain_2(true);
      settime(doc.data().time)
      console.log("type>>>>>>>..",parseInt(doc.data().time*60000));
    });
  }, []);





  const re_load = async () => {
    if (props.request == "fail") {
      setdata_gain(false);
      await props.gain_request();
      await props.gain();

      console.log("fail>>>>>.");
    } else {
      let asd = await props.teacher;
      await setcurrent_teacher(
        await asd.find((e) => e.uid == localStorage.getItem("teacher_uid"))
      );

      // setrequest_data(arr)
    }
  };

  useEffect(() => {
    re_load();
  });

  const select_time = async (e, id) => {
    setvalue(e);
    const today = e;
    var dd = String(today.getDate()).padStart(2, "0");
    var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
    var yyyy = today.getFullYear();

    let todays =
      mm +
      "/" +
      dd +
      "/" +
      yyyy +
      " " +
      today.getHours() +
      ":" +
      today.getMinutes();
    console.log(todays, e);

    const db = getFirestore();
    await updateDoc(doc(db, "request", id), {
      meeting_date: todays,
      newUser: "yes",

    }).then(() => {
      // setdata_gain(false);
    });
  };

  const start_meeting = (id) => {
    const data = { email: current_teacher.email };
    console.log("jg");
    axios
      .post(
        `https://us-central1-loverclass.cloudfunctions.net/meeting/meeting`,
        data
      )
      .then(async (response) => {
        if (!response.data.error) {
          console.log(response.data);

          const db = getFirestore();
          await updateDoc(doc(db, "request", id), {
            newUser: "yes",

            join_url: response.data.join_url,
            meeting_date:'Join Now'
          }).then(() => {
            let URL =
              response.data.join_url.replaceAll(
                "https://us04web.zoom.us/j/",
                "http://localhost:9996/?"
              ) + `?role=1?name=${current_teacher.name}`;
            window.open(`${URL}`);

          });

          setTimeout(() => {
            const data2 = { id: response.data.id };
            axios
              .post(
                `https://us-central1-loverclass.cloudfunctions.net/meeting/meeting_end`,
                data2
              )
              .then(async (res) => {
                console.log(res);
                const db = getFirestore();
                await updateDoc(doc(db, "request", id), {
                  join_url: "",
                  meeting_date: "Meeting End",
                  
                });
              });
          }, parseInt(time*60000));
        } else {
          console.log(response.data.error);
          alert(response.data.error.message);
        }
      })
      .catch((err) => console.error("e>>>>..", err));
  };

  return localStorage.getItem("teacher_uid") !== null ? (
    <>
      <Transition.Root show={open} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-10"
          initialFocus={cancelButtonRef}
          onClose={setOpen}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          <div className="fixed z-10 inset-0 overflow-y-auto">
            <div className="flex items-end sm:items-center justify-center min-h-full p-4 text-center sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel className="relative bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:max-w-lg sm:w-full">
                  <div className="bg-white px-4 pt-3 pb-2 sm:p-2 sm:pb-2">
                    <ExclamationIcon
                      className="h-9 w-9 text-red-600"
                      aria-hidden="true"
                    />
                    <div
                      style={{
                        display: "flex",
                        alignItems: "flex-start",
                        justifyContent: "flex-start",
                        flexDirection: "column",
                      }}
                    >
                      <Dialog.Title
                        as="h3"
                        className="text-lg leading-6 font-medium text-gray-900"
                      >
                        Meeting Confirmation
                      </Dialog.Title>
                      <div className="mt-2">
                        <p className="text-sm text-gray-500">
                          Are you sure you want to Start Meeting Now?
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
                    <button
                      type="button"
                      className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                      onClick={() => setOpen(false)}
                      ref={cancelButtonRef}
                    >
                      Cancel
                    </button>

                    <button
                      type="button"
                      className="text-white mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-gray-700  focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                      onClick={() => {start_meeting(uid_popup); setOpen(false);}}
                      ref={cancelButtonRef}
                    >
                      Yes
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>

      <Sidebar2 />
      <div className="relative md:ml-64 bg-blueGray-100">
        <Navbar2 />
        {/* Header */}
        <div className="relative bg-pink-600 md:pt-12 pb-10">
          <div className="px-4 md:px-10 mx-auto w-full ml-2 d-flex align-items-center justify-content-center flex-column">
            <div style={{ height: 38 }}></div>
            <div className="d-flex align-items-center flex-column pb-9">
              <h1 className="text-white font-semibold text-3xl	 text-center">
                Sheduled Teacher
              </h1>
            </div>
          </div>
        </div>
{/* <button onClick={()=>setOpen(true)}>
  Model
</button> */}
        {data_gain && data_gain_2 ? (
          <table>
            <thead>
              <tr>
                <th scope="col">Sr#</th>
                <th scope="col">Date</th>
                <th scope="col" colSpan={2}>
                  Student Name
                </th>
                <th scope="col" colSpan={2}>
                  Student Email
                </th>
                <th scope="col" colSpan={2}>
                  Meeting Date
                </th>
                <th scope="col">Action</th>
              </tr>
            </thead>
            <tbody>
              {request_data?.map((v, i) => {
                return (
                  <tr>
                    <td data-label="Sr#">{i+1}</td>
                    <td data-label="Date">{v.date}</td>
                    <td data-label=" Student Name" colSpan={2}>
                      {v.name}
                    </td>
                    <td data-label="Student Email" colSpan={2}>
                      {v.email}
                    </td>
                    <td
                      className="d-flex justify-content-between flex-wrap"
                      style={{ height: 70 }}
                      data-label="Meeting Date"
                      colSpan={2}
                    >
                      {v.meeting_date != "waiting" ? (
                        v.meeting_date
                      ) : (
                        <div
                          style={{ minWidth: "100%" }}
                          className="d-flex flex-row align-items-end justify-content-end"
                        >
                          <DateTimePicker
                            onChange={(e) => {
                              setvalue({ e: e, id: v.request_uid });
                              let arr = [array];
                              arr[i] = e;
                              setArray(arr);
                            }}
                            value={array[i]}
                          />
                          <button
                            onClick={() => {
                              select_time(value.e, value.id);
                            }}
                            disabled={array[i] == undefined ? true : false}
                            // onClick={()=>console.log("Diabaldflas")}
                            style={{
                              height: 29,
                              width: 50,
                              fontSize: 14,
                              backgroundColor: "#0275d8",
                              borderRadius: 4,
                              color: "#fff",
                              cursor:
                                array[i] == undefined
                                  ? "not-allowed"
                                  : "pointer",
                            }}
                            className="ml-1"
                          >
                            Save
                          </button>
                        </div>
                      )}
                    </td>

                    <td data-label="Meeting" style={{ height: 50 }}>
                      {v.meeting_date != "Meeting End" ? (
                        <button
                          className="btn btn-danger"
                          onClick={() => {
                            // start_meeting(v.request_uid);
                            setuid_popup(v.request_uid)
                            setOpen(true)
                          }}
                        >
                          Start Meeting
                        </button>
                      ) : (
                        ""
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        ) : (
          <div class="loading" id="loading">
            Loading&#8230;
          </div>
        )}
      </div>
    </>
  ) : (
    navigate("/Login")
  );
}

const mapStateToProps = (state) => {
  return {
    request: state.request,
    teacher: state.current_stock,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    gain_request: () => dispatch(gain_request()),
    gain: () => dispatch(gain()),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(SheduledTeacher);
